export default __webpack_public_path__ + "static/media/Etherscan.88535d85.svg";